var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    className: "list_svg__bi list_svg__bi-list",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 13.5A.5.5 0 0 1 5 13h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 5 9h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 5 5h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgList;